export default __webpack_public_path__ + "static/media/rr1.b63e4250.jpg";